/**
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks
 * owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { Card, Select, ThemeType, toggleTheme } from '@scuf/common';
import { AppContext } from '@keystone/common';
import APIClient from '../common/APIClient';

class UserPreferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: null,
    };
  }

  componentDidMount() {
    const { userData } = this.context;
    if (userData.response.preferences) {
      const { theme } = userData.response.preferences;
      if (theme) {
        this.setState({ selectedValue: theme });
      }
    } else {
      this.setState({ selectedValue: 'light' });
    }
  }

  render() {
    const { user } = this.context;
    const { selectedValue } = this.state;
    const options = [
      { value: 'light', text: 'Light' },
      { value: 'dark', text: 'Dark' },
    ];
    return (
      <Card>
        <Card.Header title="User Preferences" />
        <Card.Content>
          <Select
            label="Theme"
            value={selectedValue}
            options={options}
            onChange={(value) => {
              this.setState({ selectedValue: value });
              APIClient.updateUserPreferences(user.idToken, { theme: value });
              if (value === 'light') {
                toggleTheme(ThemeType.Light);
              }
              if (value === 'dark') {
                toggleTheme(ThemeType.Dark);
              }
            }}
          />
        </Card.Content>
      </Card>
    );
  }
}

UserPreferences.contextType = AppContext;

export default UserPreferences;
